<template>
    <div class="bax-modal-wrap" v-if="open === true">
        <div class="container full-page">
            <div class="bax-modal-content-wrap bax-bg-foot-link">
                <div class="bax-modal-content">
                    <div class="bax-icon bax-remove d-flex align-items-end justify-content-end mb-4">
                        <i class="icon-close" @click.prevent="cancelModal"></i>
                    </div>
                    <div class="formulation-form-row">
                        <div class="col-8">
                            <div class="panel top-info">
                                <h3>{{ baseInfo.label}} formulation base</h3>
                                <div class="formulation-form-row">
                                    <div class="col-12">
                                        <label>Formulation Detailed Description</label>
                                        <p>{{formData.bag_details}}</p>
                                    </div>
                                </div>
                                <template v-if="formData.use==='patient'">
                                    <h4>Patient Details</h4>
                                    <div class="formulation-form-row">
                                        <div class="col-4">
                                            <label>Initials</label>
                                            <p>{{formData.patient_initials}}</p>
                                        </div>
                                        <div class="col-8">
                                            <label>Hospital or HPN Formulation Reference</label>
                                            <p>{{formData.patient_ref}}</p>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="col-4">
                            <SavedPanel :formData="formData" />
                        </div>
                    </div>
                    <div class="formulation-form-row">
                        <div class="col-8">
                            <div class="recap-col">
                                <RecapTable :formData="formData" :baseInfo="baseInfo" :settings="settings" :showComments="true" />
                            </div>
                        </div>
                        <div class="col-4">
                            <StabilityPanel :stability="formData.stability" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


import RecapTable from '@/views/Tpn/CustomFormulationCreate/RecapTable.vue';
import StabilityPanel from '@/views/Tpn/CustomFormulationCreate/StabilityPanel.vue';
import SavedPanel from '@/views/Tpn/CustomFormulationCreate/SavedPanel.vue';

export default {
    name: 'PreviewFormulationModal',
    components: {
        RecapTable,
        StabilityPanel,
        SavedPanel
    },
    props: {
        open: {
            required: true,
        },
        formData: {
            required: true,
        },
        baseInfo: {
            required: true,
        },
        settings: {
            required: true,
        },
    },
    data() {
        return {
        };
    },
    methods: {
        cancelModal() {
            this.$emit('modal_close');
        },
    },
};
</script>
